var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',[_vm._v("# mods = "+_vm._s(_vm.modules.length))]),_vm._l((_vm.modules),function(module){return _c('div',{key:module.id},[_vm._v(" "+_vm._s(module.description)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }